(() => {
  const key = '__dsPackSelector';
  if (window[key]) { window[key](document); return; }
  const initialized = new WeakSet();
  function init(scope) {
    const root = scope.matches?.('#ds-landing') ? scope : scope.querySelector('#ds-landing');
    if (!root || initialized.has(root)) return;
    const form = root.querySelector('#ds-v1-product-form');
    if (!form) return;
    initialized.add(root);
    const quantity = form.querySelector('input[name="quantity"]');
    const content = form.querySelector('[data-ds-pack-content]');
    function sync() {
      const choice = form.querySelector('input[name="ds_pack"]:checked');
      if (!choice || !quantity) return;
      quantity.value = choice.value;
      quantity.setAttribute('value', choice.value);
      quantity.dispatchEvent(new Event('input', { bubbles: true }));
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
      if (content) content.textContent = choice.dataset.packLabel;
    }
    form.querySelectorAll('input[name="ds_pack"]').forEach(input => input.addEventListener('change', sync));
    sync();
  }
  window[key] = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
